import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { Box } from '@mui/material'
import React, { forwardRef } from 'react'
import PieChartTooltip from 'src/Libs/chart-kit/pie-charts/components/PieChartTooltip'

interface Props {
  title: string
  tooltipText?: string
  action?: React.ReactElement
}

const MIN_HEIGHT = 36 /** ensures consistent hight for all header variations (e.g. no action vs action) */

/**
 * Header for system charts of type pie chart.
 */
const PieSystemChartHeader = forwardRef<HTMLDivElement, Props>(({ title, tooltipText, action }, ref) => {
  return (
    <Box
      ref={ref}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        minHeight: MIN_HEIGHT,
        alignItems: 'center',
        mb: 2,
      }}
    >
      <Box sx={{ flex: 1, width: '100%', height: '100%', pl: 1, overflow: 'hidden' }}>{action}</Box>
      <Box sx={{ display: 'flex', flex: 4, justifyContent: 'center', overflow: 'hidden', pl: 2, pr: 2 }}>
        {title && (
          <Typography sx={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} variant={'h3'}>
            {title}
          </Typography>
        )}
      </Box>
      <Box sx={{ flex: 1 }}>{tooltipText && <PieChartTooltip text={tooltipText} />}</Box>
    </Box>
  )
})

PieSystemChartHeader.displayName = 'PieSystemChartHeader'

export default PieSystemChartHeader
